import { useRef } from 'react';

// Source: https://stackoverflow.com/a/57135211
const useScroll = () => {
  const elRef = useRef(null);
  const executeScroll = () => elRef.current.scrollIntoView();

  return [executeScroll, elRef];
};

export default useScroll;
